import { style } from 'typestyle'
export const mb8 = style({ marginBottom: '8px' })
